import * as React from 'react';

import { ChatMessageUserName } from '../../../../components/ChatMessageUserName';
import { useUserName, useUserColor } from '../../hooks';

interface IUserNameContainerProps {
  isFirstUserPhrase: boolean;
  messageUserId: number;
}

export const UserNameContainer: React.FC<IUserNameContainerProps> = ({ isFirstUserPhrase, messageUserId }) => {
  const { userName, nameReplacementImageUrl } = useUserName({
    messageUserId,
    isFirstUserPhrase,
  });

  const userColor = useUserColor(messageUserId);

  if (!userName && !nameReplacementImageUrl) {
    return null;
  }

  return (
    <ChatMessageUserName userName={userName} nameReplacementImageUrl={nameReplacementImageUrl} userColor={userColor} />
  );
};
